import { datadogLogs } from "@datadog/browser-logs";

const isBrowser = typeof window !== "undefined";

export interface LoggerParams {
  message: string;
  context?: object | undefined;
  error?: Error | undefined;
}

/**
 * A logger that utilizes DataDog logging
 *
 * Logger can expect either a string or an object
 * @param {String | LoggerParams} params: Params can be a simple string message or can be an object of type LoggerParams
 *
 * When params is of type LoggerParams, it includes a required string and an optional context and error:
 *
 * message: A required string
 *
 * context: An optional object to provide additional info;
 * note that basic user info is automatically added, see useDatadogUserProperties for we always provide
 *
 * error: An optional error that can be passed into the warn and error loggers
 *
 * See DataDog documentation for more details: https://docs.datadoghq.com/logs/log_collection/javascript/}
 */
export const logger = {
  info: (params: string | LoggerParams) => {
    if (!isBrowser) return;
    if (typeof params === "string") {
      datadogLogs.logger.info(params);
    } else {
      const { message, context } = params;
      datadogLogs.logger.info(message, context);
    }
  },
  warn: (params: string | LoggerParams) => {
    if (!isBrowser) return;
    if (typeof params === "string") {
      datadogLogs.logger.warn(params);
    } else {
      const { message, context, error } = params;
      datadogLogs.logger.warn(message, context, error);
    }
  },
  error: (params: string | LoggerParams) => {
    if (!isBrowser) return;
    if (typeof params === "string") {
      datadogLogs.logger.error(params);
    } else {
      const { message, context, error } = params;
      datadogLogs.logger.error(message, context, error);
    }
  },
};
